import { Flex, Shimmer } from '@/_components';
import { ScheduledShimmerProps } from './ScheduledShimmer.types';
import type { FC } from 'react';

export const ScheduledShimmer: FC<ScheduledShimmerProps> = () => {
  return (
    <Flex isColumn={true} gap={4}>
      <Flex gap={4}>
        <Shimmer width={32} height={32} />
        <Shimmer width={240} height={32} isFullWidth={true} />
      </Flex>
      <Flex gap={4}>
        <Shimmer width={32} height={32} />
        <Shimmer width={240} height={32} isFullWidth={true} />
      </Flex>
      <Flex gap={4}>
        <Shimmer width={32} height={32} />
        <Shimmer width={240} height={32} isFullWidth={true} />
      </Flex>
    </Flex>
  );
};
